<template>
    <div class="w-full p-0 mb-4" v-if="validAmountTermPair === false">
        <div class="p-0 px-5 rounded-md bg-white pt-4 border-viva-money-secondary-yellow border-solid">
            <div class="text-teal-500 text-lg font-bold mb-2 md:mb-0">
                We have had to change your loan details
            </div>
            <div class="text-gray-800 text-base pb-4 font-normal">
                Unfortunately, we do not offer the loan term and amount selected. We've updated your loan details to the closest 
                possible match, so please make sure you are happy with this before submitting your application.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        validAmountTermPair() {
            return this.customer.loan_pair_validity ?? true;
        },
    },
    data() {
        return {
        };
    },
    props: {
        customer: {},
    },
};
</script>

<style lang="scss">
</style>